<template>
    <div class="container mt-5">
        <message-controller></message-controller>
        <div class="row">
            <div class="col-12 text-center">
                <img class="img mb-4" src="/img/logo.png">
            </div>
            <div class="col-12 card-wrap">
                <b-card>
                    <h1 class="text-center">Přihlaš se</h1>
                    <b-form class="login" @submit.prevent="login">
                        <b-form-group
                                label-for="email">
                            <b-form-input
                                    id="email"
                                    v-model="email"
                                    type="email"
                                    required
                                    placeholder="Email"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-for="password">
                            <b-form-input
                                    id="password"
                                    v-model="password"
                                    type="password"
                                    required
                                    placeholder="Heslo"
                            ></b-form-input>
                        </b-form-group>

                        <b-button class="col-12" type="submit" variant="primary">Přihlásit</b-button>
                    </b-form>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import MessageController from "@/components/message-controller";
    export default {
        name: "login",
        components: {MessageController},
        data(){
            return {
                email : "",
                password : ""
            }
        },
        methods: {
            login: function () {
                let email = this.email;
                let password = this.password;
                this.$store.dispatch('login', { email, password })
                    .then(() => this.$router.push('/'))
                    .catch(() =>
                        this.$eventHub.$emit('openMessageController', 'error', 'Chybné přihlašovací údaje')
                    )
            }
        },
    }
</script>

<style scoped lang="scss">

    .card-wrap {
        display: flex;
        justify-content: center;

        .card {
            width: 100%;
            max-width: 400px;
        }
    }

</style>